import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
import { Delay9umexudtwyie as Delay } from './Delay.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull } from '../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Runnablezd7bpy5et5p0 as Runnable,
  Runnable$run$ref3om29tdwg29c8 as Runnable$run$ref,
} from './Runnable.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { coerceIn302bduskdb54x as coerceIn } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { boxApply1qmzdb3dh90hg as boxApply } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CancelHandler3ic7xysezxbm5 as CancelHandler } from './CancellableContinuationImpl.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NodeDispatcherClass;
function NodeDispatcher() {
  if (NodeDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        NodeDispatcher_instance = null;
        super();
        NodeDispatcher_instance = this;
      }
      scheduleQueueProcessing_nxtlcz_k$() {
        process.nextTick(this.messageQueue_1.processQueue_1);
      }
    }
    initMetadataForObject($, 'NodeDispatcher', VOID, VOID, VOID, [1]);
    NodeDispatcherClass = $;
  }
  return NodeDispatcherClass;
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    new (NodeDispatcher())();
  return NodeDispatcher_instance;
}
var ScheduledMessageQueueClass;
function ScheduledMessageQueue() {
  if (ScheduledMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(dispatcher) {
        super();
        this.dispatcher_1 = dispatcher;
        var tmp = this;
        tmp.processQueue_1 = () => {
          this.process_myqcf5_k$();
          return Unit_instance;
        };
      }
      schedule_o777if_k$() {
        this.dispatcher_1.scheduleQueueProcessing_nxtlcz_k$();
      }
      reschedule_mhlssa_k$() {
        setTimeout(this.processQueue_1, 0);
      }
      setTimeout_6sdjei_k$(timeout) {
        setTimeout(this.processQueue_1, timeout);
      }
    }
    initMetadataForClass($, 'ScheduledMessageQueue');
    ScheduledMessageQueueClass = $;
  }
  return ScheduledMessageQueueClass;
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
var WindowMessageQueueClass;
function WindowMessageQueue() {
  if (WindowMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(window_0) {
        super();
        this.window_1 = window_0;
        this.messageName_1 = 'dispatchCoroutine';
        this.window_1.addEventListener('message', (event) => {
          var tmp;
          if (event.source == this.window_1 && event.data == this.messageName_1) {
            event.stopPropagation();
            this.process_myqcf5_k$();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }, true);
      }
      schedule_o777if_k$() {
        var tmp = Promise.resolve(Unit_instance);
        tmp.then((it) => {
          this.process_myqcf5_k$();
          return Unit_instance;
        });
      }
      reschedule_mhlssa_k$() {
        this.window_1.postMessage(this.messageName_1, '*');
      }
    }
    initMetadataForClass($, 'WindowMessageQueue');
    WindowMessageQueueClass = $;
  }
  return WindowMessageQueueClass;
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
var SetTimeoutDispatcherClass;
function SetTimeoutDispatcher() {
  if (SetTimeoutDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        SetTimeoutDispatcher_instance = null;
        super();
        SetTimeoutDispatcher_instance = this;
      }
      scheduleQueueProcessing_nxtlcz_k$() {
        this.messageQueue_1.setTimeout_6sdjei_k$(0);
      }
    }
    initMetadataForObject($, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
    SetTimeoutDispatcherClass = $;
  }
  return SetTimeoutDispatcherClass;
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    new (SetTimeoutDispatcher())();
  return SetTimeoutDispatcher_instance;
}
var SetTimeoutBasedDispatcherClass;
function SetTimeoutBasedDispatcher() {
  if (SetTimeoutBasedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.messageQueue_1 = new (ScheduledMessageQueue())(this);
      }
      dispatch_qa3n0o_k$(context, block) {
        this.messageQueue_1.enqueue_uiib2n_k$(block);
      }
      invokeOnTimeout_nj9oyy_k$(timeMillis, block, context) {
        var handle = w3cSetTimeout(() => {
          block.run_mvkpxh_k$();
          return Unit_instance;
        }, delayToInt(timeMillis));
        return new (ClearTimeout())(handle);
      }
      scheduleResumeAfterDelay_iugqq8_k$(timeMillis, continuation) {
        var handle = w3cSetTimeout(() => {
          // Inline function 'kotlin.with' call
          continuation.resumeUndispatched_tyhwz7_k$(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (ClearTimeout())(handle));
      }
    }
    initMetadataForClass($, 'SetTimeoutBasedDispatcher', VOID, VOID, [Delay()], [1]);
    SetTimeoutBasedDispatcherClass = $;
  }
  return SetTimeoutBasedDispatcherClass;
}
var MessageQueueClass;
function MessageQueue() {
  if (MessageQueueClass === VOID) {
    class $ {
      constructor() {
        this.$$delegate_0__1 = ArrayDeque().new_kotlin_collections_ArrayDeque_sf0swv_k$();
        this.yieldEvery_1 = 16;
        this.scheduled_1 = false;
      }
      enqueue_uiib2n_k$(element) {
        this.add_a21854_k$(element);
        if (!this.scheduled_1) {
          this.scheduled_1 = true;
          this.schedule_o777if_k$();
        }
      }
      process_myqcf5_k$() {
        try {
          // Inline function 'kotlin.repeat' call
          var times = this.yieldEvery_1;
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_elvis_lhs = removeFirstOrNull(this);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return Unit_instance;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var element = tmp;
              element.run_mvkpxh_k$();
            }
             while (inductionVariable < times);
        }finally {
          if (this.isEmpty_y1axqb_k$()) {
            this.scheduled_1 = false;
          } else {
            this.reschedule_mhlssa_k$();
          }
        }
      }
      add_a21854_k$(element) {
        return this.$$delegate_0__1.add_utx5q5_k$(element);
      }
      add_utx5q5_k$(element) {
        return this.add_a21854_k$((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      add_phqi2m_k$(index, element) {
        this.$$delegate_0__1.add_dl6gt3_k$(index, element);
      }
      add_dl6gt3_k$(index, element) {
        return this.add_phqi2m_k$(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      remove_9lpry3_k$(element) {
        return this.$$delegate_0__1.remove_cedx0m_k$(element);
      }
      remove_cedx0m_k$(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.remove_9lpry3_k$((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      addAll_5l9v2i_k$(elements) {
        return this.$$delegate_0__1.addAll_4lah1e_k$(elements);
      }
      addAll_4lah1e_k$(elements) {
        return this.addAll_5l9v2i_k$(elements);
      }
      clear_j9egeb_k$() {
        this.$$delegate_0__1.clear_j9egeb_k$();
      }
      set_r80eul_k$(index, element) {
        return this.$$delegate_0__1.set_82063s_k$(index, element);
      }
      set_82063s_k$(index, element) {
        return this.set_r80eul_k$(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      removeAt_6niowx_k$(index) {
        return this.$$delegate_0__1.removeAt_6niowx_k$(index);
      }
      listIterator_70e65o_k$(index) {
        return this.$$delegate_0__1.listIterator_70e65o_k$(index);
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        return this.$$delegate_0__1.subList_xle3r2_k$(fromIndex, toIndex);
      }
      isEmpty_y1axqb_k$() {
        return this.$$delegate_0__1.isEmpty_y1axqb_k$();
      }
      contains_bxhpai_k$(element) {
        return this.$$delegate_0__1.contains_aljjnj_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.contains_bxhpai_k$((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        return this.$$delegate_0__1.iterator_jk1svi_k$();
      }
      get_c1px32_k$(index) {
        return this.$$delegate_0__1.get_c1px32_k$(index);
      }
      indexOf_gb589s_k$(element) {
        return this.$$delegate_0__1.indexOf_si1fv9_k$(element);
      }
      indexOf_si1fv9_k$(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return -1;
        return this.indexOf_gb589s_k$((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      get_size_woubt6_k$() {
        return this.$$delegate_0__1.size_1;
      }
    }
    initMetadataForClass($, 'MessageQueue', VOID, VOID, [KtMutableList()]);
    MessageQueueClass = $;
  }
  return MessageQueueClass;
}
var WindowClearTimeoutClass;
function WindowClearTimeout() {
  if (WindowClearTimeoutClass === VOID) {
    class $ extends ClearTimeout() {
      constructor($outer, handle, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        super(handle, $box);
      }
      dispose_3nnxhr_k$() {
        w3cClearTimeout(this.$this_1.window_1, this.handle_1);
      }
    }
    initMetadataForClass($, 'WindowClearTimeout');
    WindowClearTimeoutClass = $;
  }
  return WindowClearTimeoutClass;
}
var WindowDispatcherClass;
function WindowDispatcher() {
  if (WindowDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(window_0) {
        super();
        this.window_1 = window_0;
        this.queue_1 = new (WindowMessageQueue())(this.window_1);
      }
      dispatch_qa3n0o_k$(context, block) {
        return this.queue_1.enqueue_uiib2n_k$(block);
      }
      scheduleResumeAfterDelay_iugqq8_k$(timeMillis, continuation) {
        var handle = w3cSetTimeout_0(this.window_1, () => {
          // Inline function 'kotlin.with' call
          continuation.resumeUndispatched_tyhwz7_k$(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (WindowClearTimeout())(this, handle));
      }
      invokeOnTimeout_nj9oyy_k$(timeMillis, block, context) {
        var handle = w3cSetTimeout_0(this.window_1, Runnable$run$ref(block), delayToInt(timeMillis));
        return new (WindowClearTimeout())(this, handle);
      }
    }
    initMetadataForClass($, 'WindowDispatcher', VOID, VOID, [Delay()], [1]);
    WindowDispatcherClass = $;
  }
  return WindowDispatcherClass;
}
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
}
var ClearTimeoutClass;
function ClearTimeout() {
  if (ClearTimeoutClass === VOID) {
    class $ {
      constructor(handle, $box) {
        boxApply(this, $box);
        this.handle_1 = handle;
      }
      dispose_3nnxhr_k$() {
        w3cClearTimeout_0(this.handle_1);
      }
      invoke_py2q9a_k$(cause) {
        this.dispose_3nnxhr_k$();
      }
      toString() {
        return 'ClearTimeout[' + this.handle_1 + ']';
      }
    }
    initMetadataForClass($, 'ClearTimeout', VOID, VOID, [CancelHandler()]);
    ClearTimeoutClass = $;
  }
  return ClearTimeoutClass;
}
//region block: exports
export {
  NodeDispatcher_getInstance as NodeDispatcher_getInstance1gcng8nkmandy,
  SetTimeoutDispatcher_getInstance as SetTimeoutDispatcher_getInstance2vkq12hdscb97,
  WindowDispatcher as WindowDispatcheram3q94j2gxvn,
};
//endregion

//# sourceMappingURL=JSDispatcher.mjs.map
